import React from 'react';
import { Column, Row } from '../../../components/Grid';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import { Section } from '../../../components/Section';
import { CType } from '../../../provider/Typo3Provider/types';

const HtmlContainer = ({ bodytext = '' }: CType) => (
  <Section>
    <Row justifyContent="center">
      <Column large={8}>
        <HtmlContent htmlString={bodytext} />
      </Column>
    </Row>
  </Section>
);

export default HtmlContainer;
